import React from "react";

export default function DisclaimerV1() {
  return (
    <div
      className="sticky top-0 z-50 border-l-2 border-blue-600 bg-blue-50 px-4 py-2"
      role="note"
      aria-label="Avertissement outil documentaire"
    >
      <div className="flex items-start gap-2 max-w-5xl mx-auto">
        <span className="text-blue-600 text-base mt-0.5 flex-shrink-0" aria-hidden="true">
          ⓘ
        </span>
        <p className="text-sm leading-relaxed text-blue-900">
          <strong>GeriaScan est un outil documentaire</strong> d'aide à la révision
          médicamenteuse. Toute décision thérapeutique relève de la{" "}
          <strong>responsabilité exclusive du praticien qualifié</strong>. GeriaScan
          n'est pas un dispositif médical.
        </p>
      </div>
    </div>
  );
}
